import { render, staticRenderFns } from "./wyInfo.vue?vue&type=template&id=0ae2f4b2&scoped=true&"
import script from "./wyInfo.vue?vue&type=script&lang=js&"
export * from "./wyInfo.vue?vue&type=script&lang=js&"
import style0 from "./wyInfo.vue?vue&type=style&index=0&id=0ae2f4b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae2f4b2",
  null
  
)

export default component.exports